// Copyright (c) 2019 Comsearch, Inc., All rights reserved

const reduceReports = reports => (
  reports.reduce((a, d) => (
    a.find(dd => dd.month === d.month && dd.year === d.year)
      ? a
      : a.concat(d)
  ), [])
)

export default reduceReports
